<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M75.6599 32.6105C74.7199 31.1305 73.2599 30.1105 71.5499 29.7305L59.8599 27.1505C59.1099 26.9805 58.3499 26.9605 57.5999 27.0605C55.7099 27.1805 53.8899 28.1405 52.7399 29.8305L40.5499 47.7505C38.5699 50.6605 39.3199 54.6305 42.2399 56.6105C43.3399 57.3605 44.5899 57.7205 45.8199 57.7205C47.8599 57.7205 49.8599 56.7405 51.0999 54.9305L60.7299 40.7805L68.7199 42.5405C69.1899 42.6405 69.6699 42.7005 70.1499 42.7005C71.3899 42.7005 72.5999 42.3505 73.6599 41.6705C75.1399 40.7305 76.1599 39.2705 76.5399 37.5605C76.9199 35.8505 76.6099 34.0905 75.6599 32.6205V32.6105Z"
      fill="#CB80DE"
    />
    <path
      d="M109.13 52.8005H64.96L55.55 41.0405C55.12 40.4205 54.59 39.8705 53.93 39.4205C51.03 37.4205 47.06 38.1505 45.06 41.0505L19.58 78.0705C17.58 80.9705 18.31 84.9405 21.21 86.9405C22.31 87.7005 23.57 88.0705 24.82 88.0705C26.85 88.0705 28.84 87.1105 30.08 85.3105L41.98 68.0305L53.56 82.3805C55.98 85.3805 59.62 87.1205 63.47 87.1205H102.13V75.0805H109.13C115.28 75.0805 120.26 70.1005 120.26 63.9505C120.26 57.8005 115.28 52.8205 109.13 52.8205V52.8005Z"
    />
    <path
      d="M102.6 101.39C112.353 101.39 120.26 93.4838 120.26 83.7305C120.26 73.9771 112.353 66.0705 102.6 66.0705C92.8466 66.0705 84.9399 73.9771 84.9399 83.7305C84.9399 93.4838 92.8466 101.39 102.6 101.39Z"
      fill="#CB80DE"
    />
    <path
      d="M24.66 101.39C34.4133 101.39 42.32 93.4838 42.32 83.7305C42.32 73.9771 34.4133 66.0705 24.66 66.0705C14.9067 66.0705 7 73.9771 7 83.7305C7 93.4838 14.9067 101.39 24.66 101.39Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'McInsurance'
  }
</script>
